import { ReactNode, useState } from 'react'

import { ChildProps } from '@/common/util/props'

import SortButton from '@/components/view/atoms/button/SortButton'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'

interface Props extends ChildProps {
  disclosureNode: ReactNode
  quantity?: number
  onClickDelete?(): void
}

const DisclosureSortButton = ({ children, disclosureNode, quantity, onClickDelete }: Props) => {
  const [showing, setShowing] = useState<boolean>(false)
  return (
    <DisclosureWrapper
      disclosureNode={disclosureNode}
      onClickOutSide={() => setShowing(false)}
      off={!showing}
    >
      <SortButton
        onClick={() => setShowing(true)}
        quantity={quantity}
        selected={!!quantity}
        onClickDelete={onClickDelete}
      >
        {children}
      </SortButton>
    </DisclosureWrapper>
  )
}

export default DisclosureSortButton
